import { format } from "date-fns";
import { Link } from "react-router-dom";
import { TableRow, TableCell, IconButton, Tooltip, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CustomTable from "../../components/CustomTable";
import StatusBadge from "../../components/StatusBadge";
import { StyledTableCell } from "../../components/styled";
import { DATE_TIME_FORMAT } from "../../utils/constants";
import { truncateId, copyToClipboard } from "../../utils/helpers";
import {
  getPayoutRequests,
  PayoutRequestStatus,
} from "../../services/payoutRequest.service";

const renderHeader = () => (
  <TableRow>
    <StyledTableCell>Request ID</StyledTableCell>
    <StyledTableCell>User</StyledTableCell>
    <StyledTableCell>Credits Requested</StyledTableCell>
    <StyledTableCell>Payment Method</StyledTableCell>
    <StyledTableCell>Status</StyledTableCell>
    <StyledTableCell>Created At</StyledTableCell>
    <StyledTableCell>Actions</StyledTableCell>
  </TableRow>
);

const renderRow = (request) => (
  <TableRow key={request.id}>
    <TableCell>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title={request.id}>
          <span>{truncateId(request.id)}</span>
        </Tooltip>

        <IconButton
          size="small"
          onClick={(e) => copyToClipboard(request.id, e)}
          sx={{ padding: 0.5 }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>
    </TableCell>

    <TableCell>
      {request.user ? (
        <Box>
          <Box>{request.user.email}</Box>
          <Box sx={{ fontSize: "0.875rem", color: "#666" }}>
            {request.user.username ? `@${request.user.username}` : "N/A"}
          </Box>
        </Box>
      ) : (
        "N/A"
      )}
    </TableCell>

    <TableCell>{request.creditsRequested}</TableCell>

    <TableCell sx={{ textTransform: "capitalize" }}>{request.method}</TableCell>

    <TableCell>
      <StatusBadge status={request.status} />
    </TableCell>

    <TableCell>
      {format(new Date(request.createdAt), DATE_TIME_FORMAT)}
    </TableCell>

    <TableCell>
      <IconButton aria-label="view" component={Link} to={`${request.id}`}>
        <VisibilityIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

const statusFilterOptions = [
  { value: PayoutRequestStatus.Pending, label: "Pending" },
  { value: PayoutRequestStatus.Approved, label: "Approved" },
  { value: PayoutRequestStatus.Paid, label: "Paid" },
  { value: PayoutRequestStatus.Rejected, label: "Rejected" },
];

const PayoutRequests = () => {
  return (
    <CustomTable
      name="payout-requests"
      getItemsMethod={getPayoutRequests}
      renderHeader={renderHeader}
      renderRow={renderRow}
      columnCount={7}
      filters={{
        status: {
          type: "select",
          label: "Status",
          options: statusFilterOptions,
          defaultValue: "",
          paramName: "status",
          minWidth: 150,
        },
      }}
    />
  );
};

export default PayoutRequests;
